import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { Dialog, Button, Typography, Card, } from "@material-tailwind/react";
import { Upload } from "iconoir-react";
import {
    MediaType,
    Media,
    updateVehicleRequest,
    uploadMediaRequest,
    updateMediaRequest,
    Vehicle,
} from "../../../../redux/vehicles/actions";

import ProductView360 from '../../../../components/ProductView360';
import Loader from "../../../../components/Loader";
import { RootState } from "../../../../redux";
import AppImages from "../../../../assets/AppImages";
import FileUpload from "../../../../components/FileUpload";

const MEDIA_SECTIONS = [
    {type: "general", name: "General", id: 0, views: [] as MediaType[]},
    {type: "exterior", name: "Exterior", id: 2, views: [] as MediaType[]},
    {type: "interior", name: "Interior", id: 1, views: [] as MediaType[]},
];

export function DashboardVehicleInventoryTabMedia() {
    const dispatch = useDispatch();
    const { vehicle, mediatypes } = useSelector((state: RootState) => state.vehicles);
    const [sections, setSections] = useState(MEDIA_SECTIONS);
    const [sectionsMedias, setSectionsMedias] = useState<Record<string, Media[]>>({});
    const [show360, setShow360] = useState(false);
    const [show360Media, setShow360Media] = useState<string[]>([]);
    const [orders, setOrders] = useState<Record<number, number>>({});

    const preview360 = () => {
        setShow360Media(vehicle?.medias?.filter((media) => media.section.is_out).map((media) => media.full_url) || []);
        setTimeout(() => {
            setShow360(!show360);
        }, 100);
    }

    useEffect(() => {
        if (mediatypes.length > 0) {
            MEDIA_SECTIONS.forEach((section) => {
                const mediaType = mediatypes.find((mt) => mt.name === section.name);
                if (mediaType) {
                    section.id = mediaType.id;
                }

                if (section.name === "Interior") {
                    section.views = mediatypes.filter((mt) => mt.is_in);
                } else if (section.name === "Exterior") {
                    section.views = mediatypes.filter((mt) => mt.is_out);
                }
            });
            setSections(MEDIA_SECTIONS);
        }
    }, [mediatypes]);

    const handleOrderChange = (item: Media) => {
        if (orders[item.id] !== item.order) {
            dispatch(
                updateMediaRequest({
                    vehicle_id: vehicle?.id || 0,
                    media: {
                        id: item.id,
                        order: orders[item.id],
                    } as unknown as Media,
                    update_fields: ["id", "order"],
                })
            );
        }
    };

    useEffect(() => {
        const medias: Record<number, Media[]> = {};
        vehicle?.medias?.forEach((media) => {
            if (!medias[media.section.id]   ) {
                medias[media.section.id] = [];
            }
            medias[media.section.id].push(media);
            if (media.section.id === sections[0].id) {
                setOrders((prev) => ({ ...prev, [media.id]: media.order || 0 }));
            }
        });
        setSectionsMedias(medias);
    }, [vehicle]);

    return !vehicle ? (
        <Loader />
    ) : (
        <React.Fragment>
            <Card className="p-2 md:p-5">
                <Card.Header className="flex justify-between">
                    <div>
                        <Typography className="block font-bold text-primary">
                            Image & Video
                        </Typography>
                        <Typography type="small" className="block text-foreground">
                            Upload vehicle images and videos for customers to view.
                        </Typography>
                    </div>
                    <div className="flex items-center gap-x-3">
                        <Button
                            size="sm"
                            variant="outline"
                            color="secondary"
                            onClick={(e: any) =>
                                e.currentTarget.parentElement
                                    ?.querySelector("#general_upload")
                                    ?.click()
                            }
                            className="h-8 flex items-center gap-2 sm:w-auto w-full"
                        >
                            Upload
                            <Upload className="w-5 h-5" />
                        </Button>

                        <input
                            type="file"
                            id={"general_upload"}
                            className="hidden"
                            accept=".jpg,.png,.jpeg"
                            multiple={true}
                            onChange={(e) => {
                                const files = e.target.files;
                                dispatch(
                                    uploadMediaRequest({
                                        vehicle_id: vehicle?.id || 0,
                                        files: files as FileList,
                                        section_id: sections[0].id,
                                    })
                                );
                            }}
                        />
                    </div>
                </Card.Header>
                <Card.Body className="gap-y-5 justify-center items-center min-h-[400px] flex flex-col">
                    {sectionsMedias[sections[0].id] ? (
                        <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-5 justify-stretch">
                            {sectionsMedias[sections[0].id]
                                .sort((a, b) => (a.order || 0) - (b.order || 0)) // Sort images by 'order' property
                                .map((item, index) => (
                                    <div
                                        key={index}
                                        className="flex border min-h-[250px] border-gray-200 rounded-md flex-col items-center justify-center gap-y-3"
                                    >
                                        <FileUpload
                                            name={`img_${item.id}`}
                                            accept=".jpg,.png,.jpeg"
                                            title={`general_${item.id}`}
                                            gap="gap-y-3"
                                            desc=""
                                            media={item}
                                            onFileChange={(files) => {
                                                dispatch(
                                                    updateVehicleRequest({
                                                        vehicle: {
                                                            id: vehicle.id,
                                                            removed_medias: [item.id],
                                                        } as unknown as Vehicle,
                                                        update_fields: ["id", "removed_medias"],
                                                    })
                                                );
                                                dispatch(
                                                    uploadMediaRequest({
                                                        vehicle_id: vehicle?.id || 0,
                                                        files: files,
                                                        section_id: sections[0].id,
                                                    })
                                                );
                                            }}
                                            onFileRemove={(id) => {
                                                withReactContent(Swal)
                                                    .fire({
                                                        title: "Are you sure?",
                                                        text: "You won't be able to revert this!",
                                                        icon: "warning",
                                                        showCancelButton: true,
                                                        confirmButtonColor: "#3085d6",
                                                        cancelButtonColor: "#d33",
                                                        confirmButtonText: "Yes, delete it!",
                                                    })
                                                    .then((result) => {
                                                        if (result.isConfirmed) {
                                                            dispatch(
                                                                updateVehicleRequest({
                                                                    vehicle: {
                                                                        id: vehicle?.id || 0,
                                                                        removed_medias: [id],
                                                                    } as unknown as Vehicle,
                                                                    update_fields: [
                                                                        "id",
                                                                        "removed_medias",
                                                                    ],
                                                                })
                                                            );
                                                        }
                                                    })
                                                    .catch((error: any) => {
                                                        console.log("error", error);
                                                    });
                                            }}
                                        />
                                        <div className="flex justify-between w-full">
                                            <div className="flex items-center">
                                                #
                                                <input
                                                    type="number"
                                                    id={`order_img_${item.id}`}
                                                    value={orders[item.id]}
                                                    className="w-[60px] rounded-md border border-gray-200 p-2"
                                                    min={0}
                                                    onChange={(e) => {
                                                        setOrders((prev) => ({ ...prev, [item.id]: parseInt(e.target.value) }));
                                                    }}
                                                    onBlur={() => {
                                                        handleOrderChange(item);
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            handleOrderChange(item);
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    id={`use_img_${item.id}`}
                                                    checked={item.is_use}
                                                    onChange={(e) => {
                                                        dispatch(
                                                            updateMediaRequest({
                                                                vehicle_id: vehicle?.id || 0,
                                                                media: {
                                                                    ...item,
                                                                    is_use: e.target.checked,
                                                                } as unknown as Media,
                                                                update_fields: ["id", "is_use"],
                                                            })
                                                        );
                                                    }}
                                                />
                                                <label htmlFor={`img_${item.id}`} className="ml-2">
                                                    In Use
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    ) : (
                        <FileUpload
                            name={`img_general`}
                            isMultiple={true}
                            accept=".jpg,.png,.jpeg"
                            title="General"
                            titleClass="font-bold"
                            btnText="Choose Files"
                            gap="gap-y-5"
                            desc="Upload vehicle images and videos for customers to view."
                            media={null}
                            onFileChange={(files) => {
                                dispatch(
                                    uploadMediaRequest({
                                        vehicle_id: vehicle?.id || 0,
                                        files: files,
                                        section_id: sections[0].id,
                                    })
                                );
                            }}
                        />
                    )}
                </Card.Body>
            </Card>

            <Card className="p-5 mt-5 gap-y-5 flex flex-col">
                <Card.Header className="flex justify-between">
                    <div className="">
                        <Typography className="block font-bold text-primary">360° view</Typography>
                        <Typography type="small" className="block text-foreground">
                            Upload in the order requested to create a virtual 360º tour.
                        </Typography>
                    </div>
                    <div className="flex items-center gap-x-3">
                        <Button
                            size="sm"
                            variant="outline"
                            color="secondary"
                            className="h-8 flex items-center gap-2 sm:w-auto w-full"
                            onClick={() => {
                                preview360();
                            }}
                        >
                            Preview
                            <AppImages.iconEye className="w-5 h-5" />
                        </Button>
                    </div>
                </Card.Header>
                <Card.Body className="py-0 flex flex-col gap-8" key={Math.random()}>
                    {sections
                        .filter((section) => section.views.length > 0)
                        .map((section, index) => (
                            <div
                                key={`${index}-${section.views.length}`}
                                className="flex flex-col gap-5"
                            >
                                <Typography className="block font-bold text-primary">
                                    {section.name}
                                </Typography>
                                <div className="grid grid-cols-1 md:grid-cols-4 gap-5 justify-stretch">
                                    {section.views.map((item, index) => (
                                        <div
                                            key={index}
                                            className="flex border min-h-[250px] border-gray-200 rounded-md flex-col items-center justify-center gap-y-3"
                                        >
                                            <FileUpload
                                                name={`img_${item.id}`}
                                                accept=".jpg,.png,.jpeg"
                                                title={item.name}
                                                gap="gap-y-3"
                                                iconClass={item.icon ? "!w-8 !h-8" : "!w-5 !h-5"}
                                                btnClass="!py-1 !px-2"
                                                Icon={item.icon}
                                                desc=""
                                                media={sectionsMedias[item.id]?.[0] ?? null}
                                                onFileChange={(files) => {
                                                    if (sectionsMedias[item.id]?.[0]) {
                                                        dispatch(
                                                            updateVehicleRequest({
                                                                vehicle: {
                                                                    id: vehicle.id,
                                                                    removed_medias: [
                                                                        sectionsMedias[item.id]?.[0]
                                                                            ?.id,
                                                                    ],
                                                                } as unknown as Vehicle,
                                                                update_fields: [
                                                                    "id",
                                                                    "removed_medias",
                                                                ],
                                                            })
                                                        );
                                                    }
                                                    dispatch(
                                                        uploadMediaRequest({
                                                            vehicle_id: vehicle?.id || 0,
                                                            files: files,
                                                            section_id: item.id,
                                                        })
                                                    );
                                                }}
                                                onFileRemove={(id) => {
                                                    withReactContent(Swal)
                                                        .fire({
                                                            title: "Are you sure?",
                                                            text: "You won't be able to revert this!",
                                                            icon: "warning",
                                                            showCancelButton: true,
                                                            confirmButtonColor: "#3085d6",
                                                            cancelButtonColor: "#d33",
                                                            confirmButtonText: "Yes, delete it!",
                                                        })
                                                        .then((result) => {
                                                            if (result.isConfirmed) {
                                                                dispatch(
                                                                    updateVehicleRequest({
                                                                        vehicle: {
                                                                            id: vehicle?.id || 0,
                                                                            removed_medias: [id],
                                                                        } as unknown as Vehicle,
                                                                        update_fields: [
                                                                            "id",
                                                                            "removed_medias",
                                                                        ],
                                                                    })
                                                                );
                                                            }
                                                        })
                                                        .catch((error: any) => {
                                                            console.log("error", error);
                                                        });
                                                }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                </Card.Body>
            </Card>

            <Dialog open={show360} onOpenChange={() => setShow360(!show360)} size="xl">
                <Dialog.Overlay>
                    <Dialog.Content className="max-h-[90dvh] max-w-[90dvw] xl:max-w-[60dvw] flex justify-center items-center p-[20px] md:p-[40px]">
                        <ProductView360
                            amount={show360Media.length || 0}
                            imageList={show360Media}
                            autoplay={true}
                            speed={30}
                            className="rounded-lg"
                        />
                    </Dialog.Content>
                </Dialog.Overlay>
            </Dialog>
        </React.Fragment>
    );
}
